import { render } from "./googlercs-compliance-keywords.vue?vue&type=template&id=202c4225&scoped=true"
import script from "./googlercs-compliance-keywords.vue?vue&type=script&lang=js"
export * from "./googlercs-compliance-keywords.vue?vue&type=script&lang=js"

import "./googlercs-compliance-keywords.vue?vue&type=style&index=0&id=202c4225&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-202c4225"]])

export default __exports__